import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CallToActionSection() {
  return <section id="call-to-action-section" className="bg-secondary text-secondary-foreground py-12 md:py-20">
      <div className="page-container flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-5xl font-bold mb-6">
          Jetzt Kontakt aufnehmen
        </h2>
        
        <p className="font-sans text-lg md:text-xl text-secondary-foreground/80 mb-10 max-w-2xl">
          Wir freuen uns darauf, Ihr Projekt gemeinsam zu realisieren. Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch und lassen Sie uns Ihre Visionen in die Tat umsetzen.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
          <Button asChild size="lg" className="rounded-lg px-8 py-3 text-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
            <Link to="/ContactPage">
              Jetzt Kontakt aufnehmen
            </Link>
          </Button>
          
          <div className="flex items-center gap-3 text-secondary-foreground/90 font-medium text-lg">
            <Phone className="size-5 text-primary" />
            <span>Mobil: 0172 62 74 452</span>
          </div>
        </div>
      </div>
    </section>;
}